import {append, curry, ifElse, includes, without} from 'ramda';

export const noop = (..._args: any[]): any => {};

export const findByKey = <U extends Record<string, unknown>, K extends keyof U>(
  coll: U[],
  key: K,
  value: U[K]
): U | null => {
  if (!(coll && Array.isArray(coll))) {
    return null;
  }
  return coll.find((item) => item[key] === value) ?? null;
};

// Helper function to toggle item into list
export const toggleListItem = curry((value, list) =>
  ifElse(includes(value), without([value]), append(value))(list)
);
